import { useState, useEffect } from 'react';
import PublicQuery from 'library/util/public-query';
import { resolve } from 'library/helpers/path-resolver';

const useWithProgramFiltersData = ({ query = PublicQuery }) => {
  const [filtersResults, setFiltersResults] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getFilters = async () => {
      try {
        const result = await query(`
          {
            program_filters {
              degrees {
                ids
                name
                ui_name
              }
              program_formats {
                id
                name
                ui_name
              }
              entity_types {
                id
                name
              }
              general_filters {
                id
                name
                ui_name
              }
            }
          }
        `);

        let success = Object.keys(resolve(result, 'data/program_filters', {}))
          .length;
        if (success) {
          setFiltersResults(resolve(result, 'data/program_filters', {}));
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.error(e);
      }
    };

    getFilters();
  }, []);

  return {
    loading,
    filtersResults,
  };
};

export default useWithProgramFiltersData;
